import { API_URL } from "../configs/config";

export const getAssunto = (id) => {
  return (dispatch) => {
    dispatch({ type: "GET_ASSUNTO_REQUEST" });
    fetch(`${API_URL}/assunto/${id}`)
      .then((T) => {
        return T.json();
      })
      .then((response) => {
        return dispatch({
          type: "GET_ASSUNTO_SUCCESS",
          payload: response,
        });
      })
      .catch((error) =>
        dispatch({
          type: "GET_ASSUNTO_FAILURE",
          payload: error,
        })
      );
  };
};

export const getAssuntos = () => {
  return (dispatch) => {
    dispatch({ type: "GET_ASSUNTOS_REQUEST" });
    fetch(`${API_URL}/assunto`)
      .then((T) => {
        return T.json();
      })
      .then((response) => {
        return dispatch({
          type: "GET_ASSUNTOS_SUCCESS",
          payload: response,
        });
      })
      .catch((error) =>
        dispatch({
          type: "GET_ASSUNTOS_FAILURE",
          payload: error,
        })
      );
  };
};
